import React, { Component, Fragment } from 'react';
import { useAppState } from '../../../state';
import Chat, { Client } from 'twilio-chat';
import { Chat as ChatUI, ChatMessageSendEvent } from '@progress/kendo-react-conversational-ui';
import { Channel } from 'twilio-chat/lib/channel';
import { Message } from 'twilio-chat/lib/message';
import '@progress/kendo-theme-material/dist/all.css';
import { Member } from 'twilio-chat/lib/member';
import ChatParticipantStrip from './ChatParticipantStrip';


interface ChatDialogProps {
    username: string;
    roomNum: string;
    token: string;
    meetingNum: string;
}

class ChatKendo extends Component<any, any> {
    user: { id: any; name: any; };
    client: any;
    channel: any;
    roomNum: string;
    token: string;
    meetingNum: string;

    //const[participants, setParticipants] = useState(Array.from(room.participants.values()));

    constructor(props: ChatDialogProps) {
        super(props);

        this.state = {
            error: null,
            isLoading: true,
            messages: [],
            chatConnected: false,
            members: []
        };

        this.user = {
            id: props.username,
            name: props.username
        };

        this.roomNum = props.roomNum;
        this.token = props.token;
        this.meetingNum = props.meetingNum;

        this.setupChatClient = this.setupChatClient.bind(this);
        this.messagesLoaded = this.messagesLoaded.bind(this);
        this.messageAdded = this.messageAdded.bind(this);
        this.sendMessage = this.sendMessage.bind(this);
        this.handleError = this.handleError.bind(this);
        this.connectChat = this.connectChat.bind(this);

        this.onChannelJoin = this.onChannelJoin.bind(this);
        this.onMemberJoin = this.onMemberJoin.bind(this);
    }

    componentDidMount() {
        Chat.create(this.token)
            .then(this.setupChatClient);
    }

    connectChat() {
        const { getToken, guestName, meetingNum } = useAppState();
        getToken(guestName, meetingNum)
            .then((res: string) => JSON.parse(res))
            .then(data => Chat.create(data.token))
            .then(this.setupChatClient)
            .catch(this.handleError);
    }

    handleError(error: any) {
        console.error(error);
        this.setState({
            error: 'Could not load chat.'
        });
    }

    onChannelJoin(channel: Channel) {


    }

    onMemberJoin(m: Member) {
        // const strMsg = m.identity + ' joined chat';
        //console.log(strMsg);

        /*
        this.messageAdded({
            text: strMsg,
            author: { id: "-", name: "..." },
            timestamp: m.dateCreated
        });
        */
        /*
        this.setState({
            members: this.state.members.filter(function (member: Member) {
                return member.sid !== m.sid
            })
        })*/
        /*
        let newMembers = this.state.members.filter(function (member: Member) {
            return member.sid !== m.sid
        });*/

        let ms = [...this.state.members];
        if (ms.includes(m) === false)
            ms.push(m);

        this.setState({ members: ms });


    }

    onMemberLeft(m: Member) {
        const strMsg = m.identity + ' left chat';
        console.log(strMsg);

        /*
        this.messageAdded({
            text: strMsg,
            author: { id: "", name: "..." },
            timestamp: m.dateCreated
        });

        this.setState({
            members: this.state.members.filter(function (member: Member) {
                return member.sid !== m.sid
            })
        });
        */
    }

    setupChatClient(client: Client) {
        this.client = client;
        this.client.on('channelJoined', this.onChannelJoin);
        this.client.on('memberJoined', this.onMemberJoin);
        this.client.on('memberLeft', this.onMemberLeft);

        this.client
            .getChannelByUniqueName(this.meetingNum)
            .then((channel: Channel) => channel)
            .catch((error: any) => {
                return this.client.createChannel({ uniqueName: this.meetingNum, friendlyName: this.meetingNum });
            })
            .then((channel: Channel) => {
                this.channel = channel;
                this.channel.join();
            })
            .then(() => {
                this.setState({ isLoading: false });

                this.channel.on('memberJoined', this.onMemberJoin);
                this.channel.on('memberLeft', this.onMemberLeft);

                this.channel.getMessages().then(this.messagesLoaded);
                this.channel.on('messageAdded', this.messageAdded);
            })
            .catch(this.handleError);
    }

    twilioMessageToKendoMessage(message: Message) {

        var strIdentity = message.author;
        var intId = message.author;
        const arrName = message.author.split("::");
        if (arrName.length === 2) {
            strIdentity = arrName[0];
            intId = arrName[1];
        }

        return {
            text: message.body,
            //author: { id: message.author, name: message.author },
            author: { id: intId, name: strIdentity },
            timestamp: message.dateCreated
        };
    }

    messagesLoaded(messagePage: { items: any[]; }) {
        this.setState({
            messages: messagePage.items.map(this.twilioMessageToKendoMessage)
        });
    }

    messageAdded(message: any) {
        this.setState((prevState: { messages: any; }) => ({
            messages: [
                ...prevState.messages,
                this.twilioMessageToKendoMessage(message)
            ]
        }));
    }

    sendMessage(event: ChatMessageSendEvent) {
        this.channel.sendMessage(event.message.text);
    }

    componentWillUnmount() {
        if (this.client === undefined)
            return;
        this.client.shutdown();
    }

    render() {

        if (this.state.error) {
            return <p>{this.state.error}</p>;
        } else if (this.state.isLoading) {
            return <p>Loading chat...</p>;
        }
        return (
            <Fragment>
                <ChatParticipantStrip members={this.state.members} />
                <ChatUI
                    user={this.user}
                    messages={this.state.messages} //.filter(name=>name.includes('J'))
                    onMessageSend={this.sendMessage}
                    width={500}
                />
            </Fragment>
        );
    }
}

export default ChatKendo;

